// Módulo para interacciones con la API de Ines
class InesAPI {
  constructor() {
    this.baseUrl = 'https://ssttbeca.ines.cl/ssttbeca';
  }

  // Consultar orden existente
  async consultarOrden(orderNumber) {
    const formData = new FormData();
    formData.append('ot', orderNumber);

    const response = await fetch(`${this.baseUrl}/consulta.php`, {
      method: 'POST',
      body: formData
    });

    // INES devuelve ISO-8859-1 — decodificar correctamente antes de parsear
    const buffer = await response.arrayBuffer();
    const text = new TextDecoder('iso-8859-1').decode(buffer);
    return this.parseResponse(text);
  }

  // Crear nueva orden
  async crearOrden(orderData) {
    const productImage = orderData.productImage || '';
    const boletaImage = orderData.boletaImage || '';

    const dataWithoutImages = { ...orderData };
    delete dataWithoutImages.productImage;
    delete dataWithoutImages.boletaImage;

    const formData = new FormData();
    formData.append('data', JSON.stringify(dataWithoutImages));
    formData.append('email', orderData.email);
    formData.append('productImage', productImage);
    formData.append('boletaImage', boletaImage);

    console.log('INES-API: Enviando productImage:', productImage ? `${productImage.length} bytes, inicia con: ${productImage.substring(0, 50)}` : 'vacía');
    console.log('INES-API: Enviando boletaImage:', boletaImage ? `${boletaImage.length} bytes, inicia con: ${boletaImage.substring(0, 50)}` : 'vacía');
    console.log('INES-API: FormData keys:', Array.from(formData.keys()));
    console.log('INES-API: productImage en FormData:', formData.get('productImage') ? `${formData.get('productImage').length} bytes` : 'vacía');
    console.log('INES-API: boletaImage en FormData:', formData.get('boletaImage') ? `${formData.get('boletaImage').length} bytes` : 'vacía');

    const response = await fetch(`${this.baseUrl}/registro.php`, {
      method: 'POST',
      body: formData
    });

    const text = await response.text();
    return this.extractOrderInfo(text);
  }

  // Actualizar estado de orden
  async actualizarEstado(ordenId, estado) {
    const updateData = {
      orden_id: ordenId,
      estado: estado
    };

    const response = await fetch(`${this.baseUrl}/update.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateData)
    });

    return response.text();
  }

  // Repara JSON con comillas sin escapar y saltos de línea literales dentro de strings
  repairJSON(text) {
    let out = '';
    let inStr = false;
    let esc = false;
    for (let i = 0; i < text.length; i++) {
      const c = text[i];
      if (esc) { out += c; esc = false; continue; }
      if (c === '\\' && inStr) { out += c; esc = true; continue; }
      if (c === '"') {
        if (!inStr) {
          inStr = true; out += c;
        } else {
          let j = i + 1;
          while (j < text.length && (text[j] === ' ' || text[j] === '\t')) j++;
          const nx = text[j];
          if (nx === ',' || nx === '}' || nx === ']' || nx === ':' || j >= text.length) {
            inStr = false; out += c;
          } else {
            out += '\\"';
          }
        }
        continue;
      }
      if (inStr) {
        if (c === '\n') { out += '\\n'; continue; }
        if (c === '\r') { out += '\\r'; continue; }
        if (c === '\t') { out += '\\t'; continue; }
      }
      out += c;
    }
    return out;
  }

  // Parsear respuesta de consulta
  parseResponse(text) {
    try {
      return JSON.parse(text);
    } catch (e1) {
      try {
        return JSON.parse(this.repairJSON(text));
      } catch (e2) {
        return null;
      }
    }
  }

  // Extraer información de orden de la respuesta
  extractOrderInfo(text) {
    console.log('INES-API: Respuesta completa de INES:', text);

    let ordenId = "GENERADO";
    let pdfUrl = "";

    const urlPdfMatch = text.match(/https?:\/\/[^"\s]+pdfProducto\.php\?ticket=[0-9]+/);
    if (urlPdfMatch) {
      pdfUrl = urlPdfMatch[0].replace(/\\\//g, '/');
      console.log('INES-API: PDF URL encontrada:', pdfUrl);
    }

    const cobaMatch = text.match(/COBATFDV([0-9]+)/i);
    if (cobaMatch) {
      ordenId = "COBATFDV" + cobaMatch[1];
      console.log('INES-API: Código BECA encontrado:', ordenId);
      return { ordenId, pdfUrl };
    }

    const ticketMatch = text.match(/ticket[=:]?\s*([0-9]+)/i);
    if (ticketMatch) {
      ordenId = ticketMatch[1];
      console.log('INES-API: Ticket encontrado:', ordenId);
      return { ordenId, pdfUrl };
    }

    const patronesBusqueda = [
      /[Cc][Óóo][Dd][Ii][Gg][Oo](?:\s+)[Bb][Ee][Cc][Aa][:=\s]+([A-Za-z0-9]+)/i,
      /orden\s+(?:n[uú]mero\s+)?([0-9A-Za-z]+)/i,
      /generada.*?([0-9]{6,})/i,
      /id[=:]\s*['"]?([0-9A-Za-z]+)['"]?/i,
      /([0-9]{8,})/
    ];

    for (const patron of patronesBusqueda) {
      const coincidencia = text.match(patron);
      if (coincidencia && coincidencia[1]) {
        ordenId = coincidencia[1];
        console.log('INES-API: ID encontrado con patrón:', ordenId);
        break;
      }
    }

    console.log('INES-API: Orden ID final:', ordenId);
    return { ordenId, pdfUrl };
  }
}

// Instancia global
window.inesAPI = new InesAPI();
